export default __webpack_public_path__ + "static/media/open_gallery_04.f1a2af14.svg";